import React from "react";

import { withStyles } from "@material-ui/core/styles";

import FormComponent from "../../classes/FormComponent";
import Form from "../../components/Form";
import Typography from '@material-ui/core/Typography';

const styles = {
  formLabel: {
    fontSize: 12,
  },
};


class PauseAppDeviceForm extends FormComponent {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    if (this.state.object === undefined) {
      return null;
    }

    return(
      <Form
        submitLabel={this.state.object.pausedAt ? "Start decoding" : "Pause decoding"}
        onSubmit={this.onSubmit}
        disabled={this.props.disabled}
      >
        <div>
            <Typography variant="h6" color={this.state.object.pausedAt ? "secondary" : "primary"}>
                {this.state.object.pausedAt ? "Decoding of packets for this device has been paused" : "Decoding of packets for this device is active"}
            </Typography>
        </div>
      </Form>
    );
  }
}

export default withStyles(styles)(PauseAppDeviceForm);
